// theme.js's own FacetApplyButton counts every non-empty form field and subtracts 1 for
// "sort_by" -- but the same drawer form always carries other non-empty, non-filter hidden
// fields too ("q": search terms, or the vendor/type scoping value on automated collection
// pages; "type": search's fixed "product" scope), so it overcounts whenever those are
// present, and Sort By's own presence/absence is a fragile thing to special-case at all.
// Instead, only count fields that are actually filters -- every real filter input's name
// starts with "filter." (filter.v.availability, filter.p.m.custom.shoe_type, filter.v.price.gte,
// etc.), so this counts by that prefix directly rather than subtracting known non-filter names.
//
// The initial correction has to wait for customElements.whenDefined("facet-apply-button")
// rather than running immediately: that custom element's own <span> (which holds the
// count text) is only created once the class upgrades the element, and theme.js may
// register it from a lazily-loaded chunk well after this script's own top-level code runs.
function correctFacetApplyCount(form) {
  const applyButton = form.querySelector('[is="facet-apply-button"]');
  if (!applyButton) return;

  const formData = new FormData(form);
  const count = Array.from(formData.entries())
    .filter(([key, value]) => key.startsWith('filter.') && value !== '')
    .length;

  const countElement = applyButton.querySelector('span');
  if (countElement) countElement.innerText = ` (${count})`;
}

function correctAllFacetForms() {
  document.querySelectorAll('#facet-form').forEach(correctFacetApplyCount);
}

if (window.customElements && customElements.whenDefined) {
  customElements.whenDefined('facet-apply-button').then(correctAllFacetForms);
} else {
  correctAllFacetForms();
}

document.addEventListener('change', (event) => {
  const form = event.target.closest('#facet-form');
  if (form) correctFacetApplyCount(form);
});

document.addEventListener('click', (event) => {
  if (event.target.closest('[aria-controls="facets-drawer"]')) {
    correctAllFacetForms();
  }
});
